import React, { memo, useState, useEffect, useMemo } from "react";
import * as S from "./styled";
import Meta from "./Meta";
import Comments from "./Comments";
import PT from "prop-types";
import { PortfolioAPI } from "@/api/portfolio";
import pick from "lodash/pick";
import Counters from "./Counters";

const Aside = ({
  slide,
  favorites,
  toggleLike,
  className,
  openShareModal,
  shouldFetchSlide,
  addComment,
  removeComment,
  authUserId,
  isStandalone,
  t,
}) => {
  const isFavorite = useMemo(() => {
    return favorites.includes(slide._id);
  }, [favorites, slide._id]);
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState(null);
  const [mode, setMode] = useState("meta");
  const toggleMode = () => {
    setMode(mode === "meta" ? "comments" : "meta");
  };
  const onStarClick = () => {
    toggleLike(slide._id);
  };
  useEffect(() => {
    async function foo() {
      if (shouldFetchSlide) {
        setLoading(true);
        try {
          const { data } = await PortfolioAPI.findById(slide._id);
          setMeta(pick(data, ["client", "master", "saloon", "service"]));
        } catch (e) {
          console.error(e);
        } finally {
          setLoading(false);
        }
      }
    }
    foo();
  }, [slide._id]);
  if (!slide) return null;
  return (
    <S.Container isStandalone={isStandalone} className={className}>
      <Counters
        t={t}
        likes={slide.likes_count}
        comments={slide.comments_count}
        id={slide._id}
        isFavorite={isFavorite}
        onStarClick={onStarClick}
        toggleLike={toggleLike}
        openShareModal={openShareModal}
      />
      {mode === "meta" && (
        <Meta
          t={t}
          loading={loading}
          shouldFetchSlide={shouldFetchSlide}
          meta={shouldFetchSlide ? meta : slide}
          slide={slide}
        />
      )}
      {mode === "comments" && (
        <Comments
          t={t}
          isStandalone={isStandalone}
          authUserId={authUserId}
          addComment={addComment}
          removeComment={removeComment}
          portfolioId={slide._id}
        />
      )}
      <S.ModeToggler onClick={toggleMode}>
        {mode === "comments"
          ? t("common:info")
          : `${t("common:comments")}(${slide.comments_count})`}
      </S.ModeToggler>
    </S.Container>
  );
};
Aside.displayName = "PortfolioAside";
Aside.propTypes = {
  slide: PT.object,
  favorites: PT.array,
  className: PT.string,
  shouldFetchSlide: PT.bool,
  authUserId: PT.string,
  isStandalone: PT.bool,

  t: PT.func.isRequired,
  toggleLike: PT.func,
  openShareModal: PT.func,
  addComment: PT.func,
  removeComment: PT.func,
};

export default memo(Aside);
